import { useFormik } from 'formik';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import * as Yup from 'yup';
import { getPlbBulkUpladSample, plbBulkUplad } from '../../../../Redux/qms/action';
import { Tooltip } from '@mui/material';

  // Function to convert JSON to CSV
  const convertToCSV = (json) => {
    const { headers, records } = json;
    const csvRows = [headers.join(",")];

    records.forEach((row) => {
      const values = headers.map((header) => `"${row[header] || ""}"`);
      csvRows.push(values.join(","));
    });

    return csvRows.join("\n");
  };

const PlbBulkUpladModal = ({ job,show,setShow,setToaster }) => {
    const [plbLoader,setPlbLoader] = useState(false)
    const [plbSampleLoader,setPlbSampleLoader] = useState(false)
    const validationSchema = Yup.object().shape({
        job: Yup.string().required("Required"),
        plb_file: Yup.string().required("Required")
    })
    const formik = useFormik({
        enableReinitialize:true,
        initialValues: {
            job: show?job?.id:'',
            plb_file: '',
        },
        validationSchema: validationSchema,
        validate: (values) => {
            let errors = {};
            const validFileTypes = ['text/csv'];

            // Check for plb_file presence
            if (!values.plb_file) {
                errors.plb_file = "Required ";
            }
            if (!values.job) {
                errors.job = 'Required';
            }

            return errors;
        },

        onSubmit: (values) => {
            setPlbLoader(true)
            plbBulkUplad(values)((response)=>{
                if (response && response.status) {
                setToaster('success')
                handleClose()
            }else{
                setToaster('error')
                handleClose()
                }
            })
        },

    });
    const handleClose = () => {
        formik.resetForm();
        setShow(false)
        setPlbLoader(false)
        setPlbSampleLoader(false)      
    };
      // Function to trigger CSV download
  const downloadCSV = (data) => {
    try{
        const csvData = convertToCSV(data);
        const blob = new Blob([csvData], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${job?.job_id}-IMPORT_PLB.csv`
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }catch (errors){
        setToaster('error')
    }
    
    
  };
    const getSamplePlb = () => {
        setPlbSampleLoader(true)
        getPlbBulkUpladSample({job:job?.id})((response)=>{
            if (response && response.status) {
                setPlbSampleLoader(false)
                Object.keys(response?.data??{}).length>0&& downloadCSV(response?.data)
            }else{
                setPlbSampleLoader(false)
            }
        })
    }
    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            if (file.type !== "text/csv") {
                formik.setFieldError("plb_file", "Only CSV files are allowed.");
                return;
            }
            formik.setFieldValue("plb_file", file); // Correctly setting the file
        }
    }; 
    // console.log(formik.values);
       
    return (
        <>


            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <div className='d-flex align-items-center'>
                            Upload PLB File
                            {plbSampleLoader?
                            <div class="ms-2 spinner-border spinner-border-sm" role="status">
                            <span class="sr-only">Loading...</span>
                            </div>:
                                <button onClick={getSamplePlb} className='bg-transparent' style={{ cursor: 'pointer' }} >
                                <Tooltip disableInteractive title={'Sample Csv'} placement='top' arrow>
                                        <span className=''><i className='bi bi-download'></i></span>
                                </Tooltip>
                                </button>    
                            }
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Form >
                        <div className="my-3">
                        <p className='my-2'>Job ID: <strong>{job?.job_id}</strong></p>
                            <input
                                type="file"
                                className={`form-control ${formik.touched.plb_file && formik.errors.plb_file ? 'is-invalid' : ''}`}
                                id="file-upload"
                                name="plb_file"
                                accept='.csv'
                                onChange={(event) => {
                                    handleFileChange(event)

                                }}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.plb_file && formik.errors.plb_file && (
                                <div className="invalid-feedback">{formik.errors.plb_file}</div>
                            )}
                            <label htmlFor="plb_file-upload" className="col-form-label">
                                Upload File:  <span style={{ fontStyle: 'italic', fontSize: '12px' }}>
                                    *Only CSV files are allowed.
                                </span>
                            </label>
                        </div>
                    </Form>

                </Modal.Body>
                <Modal.Footer>
                    <Button className='btn btn-light btn-active-primary btn btn-primary' onClick={handleClose}>
                        Close
                    </Button>
                    <Button disabled={plbLoader} className='btn btn-light btn-active-primary btn btn-primary' onClick={formik.handleSubmit}>
                        {plbLoader?
                            <div class="ms-2 spinner-border spinner-border-sm" role="status">
                            <span class="sr-only">Loading...</span>
                            </div>
                        :
                        "Save Changes"
                        }
                    </Button>
                </Modal.Footer>
            </Modal>










        </>
    );
};

export default PlbBulkUpladModal;
